/**
 * Find what the lowest level of supplier in that is returned as that is the supplier that this person
 * is a part of.
 * @param person PowerScore Contact List Person.
 * @returns {number} Index (0 - 10) that is the lowest level returned (is the level before the first one to be null).
 */
export function calculateLowestSupplierLevelForPowerScoreContactListPerson(person) {
  // sid0 and sname0 should always be there
  for (let i = 1; i < 11; i++) {
    if (!person[`sid${i}`] || !person[`sname${i}`]) {
      return i - 1;
    }
  }
  return 10;
}

/**
 * Set the supplierID and supplierName to the sid and sname of the index given which should be the lowestSupplierIndex.
 * @param person PowerScore Contact List Person.
 * @param lowestSupplierIndex Index that is the lowest level of supplier in the person.
 */
export function setPowerScoreContactListPersonLowestSupplier(person, lowestSupplierIndex) {
  return {
    ...person,
    supplierId: person[`sid${lowestSupplierIndex}`],
    supplierName: person[`sname${lowestSupplierIndex}`]
  };
}

export function transformPowerScoreContactListToTreeNodes(contacts) {
  if (!Array.isArray(contacts) || !contacts.length) {
    return [];
  }

  const contactsGroupedByCompanyFamily = [];
  let currentArray;
  let parentNode;
  let lowestSupplierIndex;
  contacts.forEach(contact => {
    currentArray = contactsGroupedByCompanyFamily;
    // group by sid to lowest level of supplier existing on the contact
    for (let i = 0; i <= 10 && (contact['sid' + i] || contact['sid' + i] === 0); i++) {
      lowestSupplierIndex = 0;
      // find matching parent node for current level of sid
      parentNode = currentArray.find(treeNode => treeNode.id === `S_${contact['sid' + i]}`);
      // if parent node does not exist for this sid, create it
      if (!parentNode) {
        parentNode = {
          children: [],
          id: `S_${contact['sid' + i]}`,
          isPerson: false,
          isScore: true,
          isSupplier: true,
          name: contact['sname' + i],
          open: true,
          uiNodeId: `powerscore-supplier-S_${contact['sid' + i]}`
        };
        currentArray.push(parentNode);
      }
      // set current level being examined to the next one down
      currentArray = parentNode.children;
    }
    currentArray.push(
      transformPowerScoreContactListPersonToTreeNode(
        setPowerScoreContactListPersonLowestSupplier(contact, lowestSupplierIndex)
      )
    );
  });

  return contactsGroupedByCompanyFamily;
}

export function transformPowerScoreContactListPersonToTreeNode({
  businessTitle,
  cellPhone,
  companyKey,
  emailAddress,
  firstName,
  lastLoginSuccess,
  lastName,
  personKey,
  personStatusCode,
  poc,
  supplierId,
  supplierName,
  username,
  workPhone
}) {
  return {
    businessTitle,
    cellPhone,
    companyKey,
    emailAddress,
    isPerson: true,
    lastLoginSuccessTimestamp: lastLoginSuccess,
    leaf: true,
    name: `${firstName} ${lastName}`,
    personKey,
    personStatusCode,
    pointOfContactScore: poc,
    supplierId: `S_${supplierId}`,
    uiNodeId: `powerscore-person-${personKey}`,
    vendorName: supplierName,
    username: username,
    workPhone
  };
}
